export const HAS_DELIVERY_PROMISE = 'HAS_DELIVERY_PROMISE';
export const MISSING_DELIVERY_PROMISE = 'MISSING_DELIVERY_PROMISE';
export const DO_SHOW_MISSING_DELIVERY_PROMISE_MESSAGE = 'DO_SHOW_MISSING_DELIVERY_PROMISE_MESSAGE';
export const DO_NOT_SHOW_MISSING_DELIVERY_PROMISE_MESSAGE = 'DO_NOT_SHOW_MISSING_DELIVERY_PROMISE_MESSAGE';
export const HAS_MULTIPLE_DELIVERY_GROUPS = 'HAS_MULTIPLE_DELIVERY_GROUPS';
export const SAW_ADDRESS_FORM_WITH_AAC = 'SAW_ADDRESS_FORM_WITH_AAC';
export const HAS_LOADED_AAC_SUGGESTIONS = 'HAS_LOADED_AAC_SUGGESTIONS';
export const HAS_SELECTED_AAC_SUGGESTION = 'HAS_SELECTED_AAC_SUGGESTION';
export const HAD_SHIP_OPTION_AUTO_SELECTED = 'HAD_SHIP_OPTION_AUTO_SELECTED';
